import {Component, ElementRef, forwardRef, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {SecurityInputComponent} from '../../../../components/security-input';
import {SecurityAutocompleteModDirective} from './security-autocomplete-mod.directive';

@Component({
    selector: 'security-input',
    templateUrl: '../../../../components/security-input/security-input.component.html',
    styleUrls: ['../../../../components/security-input/security-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SecurityInputModComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SecurityInputModComponent extends SecurityInputComponent {

    @ViewChild(SecurityAutocompleteModDirective, {static: true})
    public override innerValueAccessor: SecurityAutocompleteModDirective;

    @ViewChild(SecurityAutocompleteModDirective, {read: ElementRef, static: true})
    public override innerInputElementRef: ElementRef;

}
